<template>
    <div class="content-wrapper">
        <loading :active.sync="payloading" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-8">
                        <h1 class="m-0">Apply for a Loan</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <inprocess v-if="inprocessLoan" :formProcess="loan_process"/>
            <loan-menu v-if="loanMenu" :user="user"/>
            <otp v-if="isOTP" :formOTP="prop_otp" @resend="getIndex(2)"/>
        </div>
        <!-- /main content -->
    </div>
</template>
<script>
    import LoanMenu from './section/LoanMenu.vue';
    import OTP from './section/OTP.vue';
    import Inprocess from './section/Inprocess.vue';
    import moment from 'moment';
    export default {
        components: {
            'loan-menu': LoanMenu,
            'inprocess': Inprocess,
            'otp': OTP,
        },
        data() {
            return {

                user: [],
                inprocessLoan: false,
                loanMenu: false,
                isOTP: false,
                payloading: false,

                prop_otp: {
                    countdown: 0,
                    counting: false,
                    hash_num: null,
                    code:null,
                    borrower_id:null,
                    number:null,
                    otp_id:null
                    
                },

                loan_process:[],
            }
        },

        created() {
            this.getIndex();
            Fire.$on('indexApplyLoan', () => {
                this.getIndex();
            });
        },
        methods: {
           
            getIndex(e = 1) {
                 // (activity) e 1 => generate otp, 2 => resend otp
                this.payloading = true;
                axios.post("/api/v2-check-mobile", {
                        act: e
                    })
                    .then(res => {
                        let data = res.data;
                        let req_date = data.req_otp;
                        let stat = data.otp_stat;
                        let num = data.number;

                        

                        if (data.mobile_verified) {
                            this.isOTP = false;
                            this.getInit();
                        } else {
                            this.prop_otp.hash_num = '*******' + num.substr(-4);
                            this.prop_otp.number = num;
                            this.prop_otp.borrower_id = data.borrower_id;
                            this.prop_otp.otp_id = data.session_id;

                            let today = moment().format('YYYY-MM-DD HH:mm:ss');
                            let dur = moment(req_date).add(4, 'minutes').format('YYYY-MM-DD HH:mm:ss');

                            if (today < dur) {
                                let span = moment.utc(moment(dur).diff(moment(today))).format("HH:mm:ss");
                                let remaining = moment.duration(span, "HH:mm:ss").asMinutes();
                                let ms = remaining * 60 * 1000;

                                this.prop_otp.countdown = ms;
                                this.prop_otp.counting = true;
                                // if (remaining < 4) {
                                    
                                // }
                            } else {
                                if (stat == 2) {
                                    Swal.fire({
                                        icon: 'warning',
                                        // title: title,
                                        text: 'You have exceeded the allowable OTP request. The next request will be available after 24 hours.',
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                    }).then((result) => {
                                        if (result.value) {
                                            this.$router.push('/dashboard');
                                        }
                                    })
                                }
                            }
                            this.isOTP = true;
                        }
                        this.payloading = false;
                    })
                    .catch(err => {
                        this.payloading = false;
                        console.log(err);
                    });
            },
            getInit() {
                this.payloading = true;
                this.inprocessLoan = false;
                axios.get("/api/v2-init-apply-loan")
                    .then(res => {
                        let data = res.data
                        this.user = data.user;
                        if (data.loan_process.length > 0) {

                            this.loan_process = data.loan_process;
                            this.inprocessLoan = true;
                        } else {
                            this.loanMenu = true;
                        }
                        this.payloading = false;
                    })
                    .catch(err => {
                        this.payloading = false;
                        console.log(err);
                    });
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>